
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyDetailResults',
  data() {
    return {
      type: 'core',
      indicator: this.$route.name,
    };
  },
});
